import { render, staticRenderFns } from "./DiscountBanner.vue?vue&type=template&id=35b42cb2&scoped=true&"
import script from "./DiscountBanner.vue?vue&type=script&lang=js&"
export * from "./DiscountBanner.vue?vue&type=script&lang=js&"
import style0 from "./DiscountBanner.vue?vue&type=style&index=0&id=35b42cb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b42cb2",
  null
  
)

export default component.exports